import { UiFooterNavBasicModel } from "../../models";

export function mockUiFooterNavBasicModel({
    id = "footer-nav-basic-1234",
    type = "uiFooterNavBasic",
    locale = "en",
    content = mockUiFooterNavBasicModelContent()
}: Partial<UiFooterNavBasicModel> = {}): UiFooterNavBasicModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiFooterNavBasicModelContent = UiFooterNavBasicModel["content"];

export function mockUiFooterNavBasicModelContent({
    entryTitle = "Test basic footer",
    selectLanguageLabel = "Select a language",
    ...optionals
}: Partial<UiFooterNavBasicModelContent> = {}): UiFooterNavBasicModelContent {
    return {
        entryTitle,
        selectLanguageLabel,
        ...optionals
    };
}
